import "./App.css";
import CollectJsComponent from "./components/collectJs";

function App() {
  return <CollectJsComponent />;
}

export default App;
